import { PrimaryButton } from "components/Button/style";
import { Popover } from "react-bootstrap";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.h2`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 6px;
`;

export const Button = styled(PrimaryButton)`
  width: 100px;
  padding: 0.5rem 1rem;
  font-size: 12px !important;
`;

export const ButtonIcon = styled(PrimaryButton)`
  width: 40px;
  height: 2.2rem;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px !important;
  flex-shrink: 0;
`;

export const DivAcoes = styled.div`
  position: absolute;
  right: 35px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;
`;

export const BarraFiltroRapido = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 4px;
`;

export const PagamentoUrgenteContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.9rem;
  font-weight: 500;

  .form-check-inline {
    margin-right: 0;
  }

  .form-check-input:checked {
    background-color: ${({ theme }) => theme.colors.project.main};
    border-color: ${({ theme }) => theme.colors.project.main};
  }
`;

export const TagCustoExtra = styled.span`
  background-color: #f5f5f5;
  border: 1px solid #7f7f7f;
  border-radius: 50px;
  color: #7f7f7f;
  padding: 3px 8px;
  font-size: 0.75rem;
  white-space: nowrap;
  cursor: pointer;
`;

export const CustosCelula = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

export const AlertaAReceber = styled.span`
  color: #fe8f14;
  margin-left: 4px;
`;

export const FlagUrgente = styled.span`
  color: #ee5353;
  font-size: 0.9rem;
`;

export const FlagSemArquivo = styled.span`
  color: #fe8f14;
  font-size: 0.9rem;
  margin-left: 4px;
  cursor: pointer;
`;

export const StatusBadge = styled.span<{ tipo: string }>`
  display: inline-block;
  line-height: 1.2;
  padding: 3px 10px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ tipo }) =>
    tipo === "PAGO" ? "#1f9d57" : tipo === "VALIDADO" ? "#2529f4" : "#fe8f14"};
  background-color: ${({ tipo }) =>
    tipo === "PAGO" ? "#e6f7ee" : tipo === "VALIDADO" ? "#e9e9fe" : "#fff4e6"};
  border: 1px solid
    ${({ tipo }) =>
      tipo === "PAGO" ? "#1f9d57" : tipo === "VALIDADO" ? "#2529f4" : "#fe8f14"};
`;

export const AcoesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 0.95rem;
  padding: 6px 0;

  && {
    overflow: visible;
  }

  span {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.neutral.neutral70};
    display: inline-flex;
    position: relative;
  }
`;

export const AlertaHistorico = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.warning.main};
  transform: translate(-60%, -35%);
  pointer-events: none;
`;

export const ExportPopover = styled(Popover)`
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.16);

  .popover-arrow {
    display: none;
  }
`;

export const ExportMenu = styled.div`
  min-width: 240px;
  padding: 6px;
`;

export const ExportMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;

  svg {
    color: #4b5563;
    flex-shrink: 0;
  }

  &:hover {
    background-color: #f3f4f6;
  }
`;

export const ExportItemTitulo = styled.div`
  font-size: 0.9rem;
  color: #111827;
`;

export const ExportItemSubtitulo = styled.div`
  font-size: 0.75rem;
  color: #9ca3af;
`;
